import React from "react";
import { Box, TextField, Typography } from "@mui/material";

const CustomInput = ({ label, required, className, InputLabelProps, ...props }) => {
  const labelStyle = InputLabelProps?.style || {};
  return (
    <Box className="flex flex-col">
      {label && (
        <Typography
          component="label"
          className="text-sm font-medium text-gray-700"
          style={labelStyle}
        >
          {label} {required && <span style={{ color: 'red' }}>*</span>}
        </Typography>
      )}
      <TextField
        className={props?.className ? props?.className : "form-input-moz"}
        InputLabelProps={InputLabelProps}
        {...props}
      >
        {props.children}
      </TextField>
    </Box>
  );
};

export default CustomInput;
